import classNames from "classnames";

import type {ISearchComboboxGroupProps} from "../types/ISearchComboboxGroupProps";
import {SearchComboboxInlineOption} from "./SearchComboboxInlineOption";

import * as styles from "./SearchComboboxGroup.module.css";

/** Group of rows with an uppercase caption ("OSTATNIO WYSZUKIWANE") and an optional action on the right ("Wyczyść"). */
export const SearchComboboxGroup = (props: ISearchComboboxGroupProps) => {
    const {title, labelId, action, children, className, dataTestId} = props;

    return (
        <div role="group" aria-labelledby={labelId} className={classNames(styles.group, className)} data-testid={dataTestId}>
            <div role="presentation" className={styles.header}>
                <span id={labelId} className={styles.title}>
                    {title}
                </span>
                {action ? <SearchComboboxInlineOption {...action} baseClassName={styles.action} activeClassName={styles.actionActive} /> : null}
            </div>
            {children}
        </div>
    );
};
import classNames from "classnames";

import type {ISearchComboboxGroupProps} from "../types/ISearchComboboxGroupProps";
import {SearchComboboxInlineOption} from "./SearchComboboxInlineOption";

import * as styles from "./SearchComboboxGroup.module.css";

/** Group of rows with an uppercase caption ("OSTATNIO WYSZUKIWANE") and an optional action on the right ("Wyczyść"). */
export const SearchComboboxGroup = (props: ISearchComboboxGroupProps) => {
    const {title, labelId, action, children, className, dataTestId} = props;

    return (
        <div role="group" aria-labelledby={labelId} className={classNames(styles.group, className)} data-testid={dataTestId}>
            <div role="presentation" className={styles.header}>
                <span id={labelId} className={styles.title}>
                    {title}
                </span>
                {action ? <SearchComboboxInlineOption {...action} baseClassName={styles.action} activeClassName={styles.actionActive} /> : null}
            </div>
            {children}
        </div>
    );
};
